import { createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/compleet-persoprofiler.svg'


const _withScopeId = n => (_pushScopeId("data-v-7f2e3d36"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "login-card",
  class: "flex flex-col"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    id: "login-card-logo",
    alt: "logo",
    src: _imports_0
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_alert = _resolveComponent("el-alert")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.view), { class: "mb-2" })),
    (_ctx.successMessage)
      ? (_openBlock(), _createBlock(_component_el_alert, {
          key: 0,
          title: _ctx.successMessage,
          type: "success"
        }, null, 8, ["title"]))
      : _createCommentVNode("", true),
    (_ctx.errorMessage)
      ? (_openBlock(), _createBlock(_component_el_alert, {
          key: 1,
          title: _ctx.errorMessage,
          type: "error"
        }, null, 8, ["title"]))
      : _createCommentVNode("", true)
  ]))
}